<template>
  <div class="login-page text-center">
    <wd-col class="col-logo">
      <wd-img width="80" :src="require('@/assets/png/login/logo.png')"/>
    </wd-col>
    <!--        <wd-button @click="init">init</wd-button>-->
    <wd-col class="col-tel_com_logo">
      <wd-img width="16" height="16" :src="require('@/assets/png/login/tel_com_logo.png')"/>
      <span>天翼账号提供认证服务</span>
    </wd-col>
    <wd-col class="col-phone">
      <input v-model="form.phone" placeholder="请输入手机号"/>
    </wd-col>

    <wd-col class="col-phone">
      <input v-model="form.code" placeholder="请输入验证码"/>
    </wd-col>

    <wd-col class="col-btn-code">
      <button :disabled="sendCodeLoading" class="bg-white round-8" @click="getSmsCode">
        <span v-if="!sendCodeLoading">获取验证码</span>
        <span v-else>{{ sendCodeShowMsg }}</span>
      </button>
    </wd-col>

    <wd-col class="col-btn-login">
      <button class=" round-8 shadow-1" :disabled="loginLoading" style="background-color: #00A4E1"
              :class="[loginLoading?'loginLoading':'']" @click="doLogin">登录
      </button>
    </wd-col>
  </div>
</template>

<script>
import {login, sendCode} from "@/api/index.api";
import {initAppUser} from "@/api/tianyi/tianyi.api";

export default {
  name: "Login",
  data() {
    return {
      loginLoading: false,
      sendCodeShowMsg: '',
      sendCodeCountDown: 60,
      sendCodeLoading: false,
      form: {
        phone: '',
        code: ''
      }
    }
  },
  created() {
    this.getPublicKey()
    let ua = navigator.userAgent.toLowerCase()
    if (isWeixinBrowser()) {
      this.$router.push('/index')
    }
    function isWeixinBrowser() {
      return /micromessenger/.test(ua) ? true : false
    }
  },
  methods: {
    init() {
      initAppUser()
    },
    getPublicKey() {
      this.$store.dispatch("User/getPublicKey");
    },
    setTime() {
      const _this = this
      if (this.sendCodeCountDown === 0) {
        this.sendCodeLoading = false
        this.sendCodeCountDown = 60;
      } else {
        this.sendCodeLoading = true
        this.sendCodeShowMsg = "重新发送(" + this.sendCodeCountDown + ")";
        this.sendCodeCountDown--;
        setTimeout(function () {
          _this.setTime()
        }, 1000)
      }
    },
    getSmsCode() {
      if (this.form.phone === '') {
        this.$toast.error('请输入手机号')
        return false
      }
      sendCode(this.form.phone).then(resp => {
        if (resp.code === 0) {
          this.$toast.success('发送成功');
          this.setTime()
        } else {
          this.$toast.error(resp.msg);
          setTimeout(function () {
            location.reload();
          }, 2500)
        }
      })
    },
    doLogin() {

      const _this = this
      if (this.form.phone === '') {
        this.$toast.error('请输入手机号')
        return false
      }
      if (this.form.code === '') {
        this.$toast.error('请输入短信验证码')
        return false
      }
      this.loginLoading = true
      login(this.form).then(resp => {
        if (resp.code === 0) {
          this.$store.dispatch('User/setUserInfo', resp.data).then(res => {
            _this.$store.dispatch("User/getUploadDetails", _this.$store.getters["User/user"].appUser.token)
          });
          this.$router.push("/lotto").then(() => {
            this.$toast.success('登陆成功');
          })
        } else {
          this.$toast.error(resp.msg);
        }
      })
    }
  }
}
</script>

<style lang="scss">
.login-page {
  height: 100%;
  background-color: white !important;

  .loginLoading {
    opacity: 0.6;
    cursor: not-allowed; //添加 cursor 属性并设置为 "not-allowed" 来设置一个禁用的图片
  }

  .col-logo {
    padding: 40px 24px 0 24px;
  }

  .col-tel_com_logo {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #aaa;
    text-align: left;
    padding: 40px 0 0 44px;
    font-size: 12px;
  }

  .col-phone {
    padding: 4px 44px 0 44px;

    input {
      width: 100%;
      height: 40px;
      border: none;
      border-bottom: #ccc 1px solid;
      background-color: transparent;
      font-size: 16px;

      &:focus {
        outline: none;
      }

      &:focus:not(:focus-visible) {
        outline: none !important;
      }

      &:focus-visible {
        outline: none !important;
      }
      &:-moz-focusring {
        outline: none !important;
      }

      &::-webkit-input-placeholder { /* WebKit browsers */
        color: #ccc;
        font-size: 16px;
      }

      &::-moz-placeholder { /* Mozilla Firefox 19+ */
        color: #ccc;
        font-size: 16px;
      }

      &:-ms-input-placeholder { /* Internet Explorer 10+ */
        color: #ccc;
        font-size: 16px;
      }
    }
  }

  .col-btn-code {
    padding: 24px 40px 0 40px;

    button {
      width: 100%;
      height: 40px;
      border: none;
      color: #666;
      font-size: 16px;
      &:-moz-focusring {
        outline: none !important;
      }
      &:focus {
        outline: none;
      }

      &:active {
        color: #aaa;
        opacity: 0.9;
      }

    }
  }


  .col-btn-login {
    padding: 24px 40px 0 40px;

    button {
      width: 100%;
      height: 40px;
      border: none;
      color: white;
      font-size: 16px;
      &:-moz-focusring {
        outline: none !important;
      }
      &:focus {
        outline: none;
      }

      &:active {
        color: #efefef;
        opacity: 0.9;
        box-shadow: 0 1px 2px 2px rgba(#2d8ff5, .15), 0 0 2px 2px rgba(#2d8ff5, .15);
      }

    }
  }
}
</style>
